import { IDepartmentInitialState } from "../../../types/master/departmentInterface";
import { DepartmentActionTypes, DepartmentActions } from "../../actionTypes/master/departmentActionTypes";


const initialState: IDepartmentInitialState = {
  departmentList: [],
  departmentData: {
    id: 0,
    department_label: "",
    slug: "",
    created_by: 0,
  },
  departmentListPageCount: 0,
};

export default function departmentReducer(state = initialState, action: DepartmentActionTypes): IDepartmentInitialState {
  switch (action.type) {

    case DepartmentActions.SET_DEPARTMENT_LIST:
      return {
        ...state,
        departmentList: action.payload,
      };

    case DepartmentActions.SET_DEPARTMENT_LIST_PAGE_COUNT:
      return {
        ...state,
        departmentListPageCount: action.payload
      };

    case DepartmentActions.SET_DEPARTMENT_DATA_BY_ID:
      return {
        ...state,
        departmentData: action.payload,
      };

    default:
      return state;
  }
}